module.exports = __webpack_public_path__ + "03_face.aec08b66.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer1/03_face.png
// module id = KDoW
// module chunks = 0